<template>
    <CommandEditorComponent title="Action group editor" :command-id="$route.params.id" />
</template>

<script>

import CommandEditorComponent from "@/components/Command/CommandEditorComponent";

export default {
    name: "ActionGroupEditView",
    components: {CommandEditorComponent},
}
</script>

<style scoped>

</style>
